import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom/client';

import * as analytics from 'analytics/Analytics';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import LadderBandsEditor from 'molbio/virtual-digests/LadderBandsEditor';
import * as ladders from 'molbio/virtual-digests/Ladders';
import notifications from 'notifications';
import OwnablesManageView from 'profile/OwnablesManageView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {BasicEvent} from 'util/Types';

let laddersCollection: ladders.Collection | null = null;

class LaddersView extends OwnablesManageView<ladders.Model> {
  override type!: string;
  override modelType!: string;
  override ownables!: ladders.Collection;
  ladderBandsEditorReactRoot: ReactDOM.Root | null = null;

  static initClass(): void {
    this.prototype.el = '.js-ladders';
    this.prototype.type = 'ladders';
    this.prototype.modelType = ModelTypeConstants.LADDER;
  }

  override events(): Backbone.EventsHash {
    return {
      ...super.events(),
      'submit .create-new form': 'createNewLadder',
    };
  }

  override die(): Promise<void> {
    return super.die([this.ladderBandsEditorReactRoot], () => {
      this.ladderBandsEditorReactRoot = null;
    });
  }

  static getBootstrappedOwnables(): ladders.Collection {
    if (laddersCollection == null) {
      laddersCollection = new ladders.Collection(window.bootstrap!.ladders);
    }
    return laddersCollection;
  }

  saveBandsForReact(parsedBands: Array<number>): Promise<void> {
    return new Promise((resolve, reject) => {
      this.currentOwnable
        .save({band_sizes: parsedBands}, {patch: true, url: `${this.currentOwnable.url()}/attributes`})
        .done(() => {
          notifications.success('Ladder successfully saved.');
          resolve();
        })
        .fail((error: Response) => {
          notifications.notifyError(error);
          // We have already notified the user of the error, so we don't need to reject here.
          resolve();
        });
    });
  }

  createNewLadder(e: BasicEvent): void {
    e.preventDefault();
    const ladder = new ladders.Model({
      name: this.$el.find('.create-new .name').val() as string,
      description: this.$el.find('.create-new .description').val() as string,
      owner_id: window.bootstrap!.current_entity_id,
    });
    ladder
      .save()
      .fail(notifications.notifyError)
      .done(() => {
        this.$el.find('.create-new .name, .create-new .description').val('');
        this.ownables.add(ladder);
        this.navigateToOwnable(ladder.id);
        notifications.success('Ladder created successfully!');
        analytics.track('DATA_MANAGEMENT', 'created_ownable', {
          type: this.type,
          name: ladder.get('name'),
          has_description: (ladder.get('description') ?? '').length > 0,
        });
      });
  }

  override renderOwnable(): void {
    super.renderOwnable();
    const list = this.currentOwnable;
    const {writable} = list.get('permissions');

    this.ladderBandsEditorReactRoot = renderToDOM(
      <LadderBandsEditor
        key={list.id}
        bandSizes={list.bandSizes()}
        isReadOnly={!writable}
        onSave={async (parsedBands) => {
          await this.saveBandsForReact(parsedBands);
        }}
      />,
      this.el.querySelector('.ladder-bands-editor'),
      this.ladderBandsEditorReactRoot
    );

    $.getJSON(`/1/api/ladders/${list.id}/collaborators/`)
      .done((res) => {
        this.createCollaboratorsView(res);
      })
      .fail(notifications.notifyError);
  }
}
LaddersView.initClass();

export default LaddersView;
